import { render, staticRenderFns } from "./project-details.vue?vue&type=template&id=68f9cfa8&scoped=true"
import script from "./project-details.vue?vue&type=script&lang=js"
export * from "./project-details.vue?vue&type=script&lang=js"
import style0 from "./project-details.vue?vue&type=style&index=0&id=68f9cfa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9cfa8",
  null
  
)

export default component.exports